document.addEventListener("DOMContentLoaded", function() {
  let lastScrollTop = 0;
  const logo = document.querySelector('.header-logo__image-container');
  const fadeStart = 150;
  const fadeEnd = 50;

  if (!logo) return;

  window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop < fadeEnd) {
      logo.style.opacity = 0;
      logo.classList.remove('show-logo');
    } else if (scrollTop < lastScrollTop) {
      logo.classList.add('show-logo');

      if (scrollTop < fadeStart) {
        const opacity = (scrollTop - fadeEnd) / (fadeStart - fadeEnd);
        logo.style.opacity = opacity;
      } else {
        logo.style.opacity = 1;
      }
    } else {
      logo.style.opacity = 0;
      logo.classList.remove('show-logo');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
});